import { useQuery } from '@tanstack/react-query';

import { getBankingInfoService } from '@/services/bankingInfo';

export const useGetBankingInfo = () => {
  const { data, isPending } = useQuery({
    queryKey: ['banking-info'],
    queryFn: getBankingInfoService,
  });

  return {
    bankingInfo: data || null,
    isPending,
  };
};
